import React from 'react'
import PropTypes from 'prop-types'

import TimeFormatter from 'infra/TimeFormatter'

export default class TimeAllocationRow extends React.PureComponent {

  static propTypes = {
    lineItemJob: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
  }

  renderTotalText(totalTime) {
    return (
      <div
        key={'total'}
        style={{ display: 'flex', flexGrow: 1, minWidth: 64,
          alignItems: 'center', justifyContent: 'flex-end', paddingLeft: 16,
          paddingRight: 16 }}>
        <span
          style={{ fontSize: 14 }}>
          { TimeFormatter.toHoursMinutesFormat(totalTime) }
        </span>
      </div>
    )
  }

  renderTime(time, index) {
    return (
      <div
        key={index}
        style={{ display: 'flex', flexGrow: 0, flexShrink: 0,
          justifyContent: 'center', alignItems: 'center', width: 80,
          borderRight: '1px solid #e4e7ea' }}>
        <span
          style={{ fontSize: 14 }}>
          { TimeFormatter.toHoursMinutesFormat(time) }
        </span>
      </div>
    )
  }

  renderNameText(text, column, width) {
    return (
      <div
        key={`${text}-${column}`}
        style={{ display: 'flex', flexShrink: 0, alignItems: 'center',
          paddingLeft: 16, paddingRight: 16, paddingTop: 4, paddingBottom: 4, width,
          borderLeft: '1px solid #e4e7ea', borderBottom: '1px solid #e4e7ea' }}>
        <span
          style={{ textAlign: 'start', fontSize: 14}}>
          { text }
        </span>
      </div>
    )
  }

  render() {
    return (
      <div
        key='header'
        style={{ display: 'flex', flexDirection: 'row', minHeight: '48px' }}>

        { this.renderNameText(this.props.lineItemJob.jobName, 'job', 100) }
        { this.renderNameText(this.props.lineItemJob.lineItem, 'item', 154) }

        <div
          style={{ display: 'flex', flexDirection: 'row', flexGrow: 1,
            border: '1px solid #e4e7ea', borderBottomWidth: 0, backgroundColor: '#fafbfc' }}>
          { this.props.lineItemJob.times.map((timeInfo, index) => this.renderTime(timeInfo, index)) }
          { this.renderTotalText(this.props.lineItemJob.totalTime) }
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/reports/timeAllocation/TimeAllocationRow.js